export function loadFrame(src) {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = src;
    try {
        document.body.appendChild(iframe);
    }
    catch (error) {
        console.error('Failed to append iframe to document body:', error);
        throw new Error('Failed to load frame');
    }
    return iframe;
}
/**
 * Listens for a postMessage event from a specified origin within a timeout period in created iframe
 */
export function listenForPostMessage(url, timeout, state) {
    let iframe;
    let messageHandler;
    let timeoutId;
    const expectedOrigin = url.origin;
    const messagePromise = new Promise((resolve, reject) => {
        messageHandler = (event) => {
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!event.data || event.data.state !== state) {
                return;
            }
            if (event.origin !== expectedOrigin) {
                reject(new Error('Message from unexpected origin'));
                return;
            }
            if (event.data.error) {
                reject(new Error(`${event.data.error}${event.data.error_description ? ' - ' + event.data.error_description : ''}`));
                return;
            }
            resolve(event.data);
        };
        window.addEventListener('message', messageHandler);
        iframe = loadFrame(url.toString());
    });
    const timeoutPromise = new Promise((_, reject) => {
        timeoutId = window.setTimeout(() => {
            reject(new Error('Waiting for postMessage timed out'));
        }, timeout);
    });
    return Promise
        .race([messagePromise, timeoutPromise])
        .finally(() => {
        window.removeEventListener('message', messageHandler);
        clearTimeout(timeoutId);
        if (document.body.contains(iframe)) {
            document.body.removeChild(iframe);
        }
    });
}
